import { useState, useEffect } from "react";

function RoomGallery({ photos }) {
  const [isOpen, setIsOpen] = useState(false);
  const [current, setCurrent] = useState(0);

  // ESC
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, []);

  if (!photos || photos.length === 0) return null;

  return (
    <>
      {/* IMAGE */}
      <div
        className="relative w-full md:w-[180px] h-[140px] flex-none cursor-pointer"
        onClick={() => {
          setCurrent(0);
          setIsOpen(true);
        }}
      >
        <img
          src={photos[0]}
          className="w-full h-full object-cover rounded-xl transition duration-300"
        />

        {/* +X */}
        {photos.length > 1 && (
          <div className="
            absolute bottom-2 right-2
            bg-black/60 text-white text-xs px-2 py-1 rounded-md
          ">
            +{photos.length - 1}
          </div>
        )}
      </div>

      {/* MODAL */}
      {isOpen && (
        <div
            className="fixed inset-0 bg-black/90 z-[9999] flex flex-col"
        >

            {/* HEADER */}
            <div className="flex justify-between items-center p-4 text-white">
            <span>{current + 1} / {photos.length}</span>
            <button onClick={() => setIsOpen(false)}>✕</button>
            </div>

            {/* IMAGE */}
            <div className="flex-1 flex items-center justify-center">
            <img
                src={photos[current]}
                className="max-h-[85vh] max-w-full object-contain"
                draggable={false}
            />
            </div>

            {/* NAV */}
            <div className="flex justify-between p-4 text-white text-2xl">
            <button
                onClick={() =>
                setCurrent((prev) =>
                    prev === 0 ? photos.length - 1 : prev - 1
                )
                }
            >
                ←
            </button>

            <button
                onClick={() =>
                setCurrent((prev) =>
                    prev === photos.length - 1 ? 0 : prev + 1
                )
                }
            >
                →
            </button>
            </div>

        </div>
        )}
    </>
  );
}

export default RoomGallery;